var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-video-banner_ext"})
}
var staticRenderFns = []

export { render, staticRenderFns }